module.exports = __webpack_public_path__ + "img/violet_073.acfe5cd1.png";